<template>
  <Starfield>
    <iColumn>
      <iRow justify-content="space-between">
        <iRow width="hug">
          <iHeading variant="accent" @click="returnToAppSelection">
            R2-D2
          </iHeading>
          <iHeading variant="subtle">
            /
          </iHeading>
          <iHeading variant="subtle">
            Create Devbox
          </iHeading>
        </iRow>
        <iRow width="hug">
          <iHeading variant="accent" @click="logout">
            force quit
          </iHeading>
        </iRow>
      </iRow>
      <iRow justify-content="center">
        <iColumn width="hug">
          <iHeading variant="accent">
            Create Devbox
          </iHeading>
          <iTextInput
            v-model="devboxName"
            label="Devbox Name"
            name="devbox_name"
            :disabled="creating"
          />
          <iRow width="hug">
            <iButton
              :disabled="!devboxName || creating"
              :is-loading="creating"
              loading-spinner-variant="light"
              @click="onCreate"
            >
              Create
            </iButton>
            <iButton
              v-if="running"
              variant="secondary"
              @click="killDevboxCreate"
            >
              Kill
            </iButton>
          </iRow>
          <iText v-if="statusLabel" variant="subtle">
            {{ statusLabel }}
          </iText>
          <iText v-if="lastError" variant="subtle">
            {{ lastError }}
          </iText>
          <pre v-if="log" ref="logPre" class="devbox-log">{{ log }}</pre>
        </iColumn>
      </iRow>
    </iColumn>
  </Starfield>
</template>

<script>

import { mapActions, mapState } from "pinia";
import { useDevboxStore } from "@/stores/devbox-store";
import { useGeneralStore } from "@/stores/general-store";
import Starfield from "@/components/Starfield";

export default {
  name: "CreateDevbox",
  components: { Starfield },
  data() {
    return {
      devboxName: "",
    };
  },
  computed: {
    ...mapState(useDevboxStore, ["creating", "currentDevboxName", "log", "running", "done", "lastError"]),
    statusLabel() {
      if (this.done) {
        return `Devbox "${this.currentDevboxName}" is ready.`;
      }
      if (this.running) {
        return `Creating devbox "${this.currentDevboxName}"…`;
      }
      if (this.currentDevboxName && !this.creating) {
        return `Devbox creation for "${this.currentDevboxName}" stopped.`;
      }
      return "";
    },
  },
  watch: {
    log() {
      this.$nextTick(() => {
        const pre = this.$refs.logPre;
        if (pre) {
          pre.scrollTop = pre.scrollHeight;
        }
      });
    },
  },
  beforeUnmount() {
    this.stopPolling();
  },
  methods: {
    ...mapActions(useDevboxStore, ["createAiWorkflowDevbox", "killDevboxCreate", "stopPolling"]),
    ...mapActions(useGeneralStore, ["logout"]),
    onCreate() {
      this.createAiWorkflowDevbox(this.devboxName);
    },
    returnToAppSelection() {
      window.location.href = "/";
    },
  },
};
</script>

<style scoped>
.devbox-log {
  width: 600px;
  max-height: 400px;
  overflow: auto;
  background: rgba(0, 0, 0, 0.5);
  color: #c9c9c9;
  padding: 12px;
  font-family: monospace;
  font-size: 12px;
  white-space: pre-wrap;
  word-break: break-all;
  border-radius: 4px;
}
</style>
